import React from "react";
import { useForm } from "react-hook-form";
import { Form, FormActions, FormFields, FormTextField, Stack } from "sprint-common-web";

import { CreateSystemFormInputs } from "./CreateSystemFormInputs";
import { useCreateSystemForm } from "./useCreateSystemForm";

export interface CreateSystemFormProps {
    onCancel(): void;
    onSubmit(): void;
}

export const CreateSystemForm: React.FC<CreateSystemFormProps> = (props: CreateSystemFormProps) => {
    const { addSystem } = useCreateSystemForm();

    const { errors, control, formState, handleSubmit, reset } = useForm<CreateSystemFormInputs>({
        defaultValues: {
            name: "",
            description: ""
        },
        criteriaMode: "all"
    });

    const handleCreateSystem = async (inputs: CreateSystemFormInputs) => {
        await addSystem(inputs);
        props.onSubmit();
    };

    const handleCancelButtonClick = () => {
        reset();
        props.onCancel();
    };

    return (
        <Form onSubmit={handleSubmit(handleCreateSystem)}>
            <FormFields>
                <Stack>
                    <FormTextField
                        label="Name"
                        control={control}
                        name="name"
                        errors={errors}
                        rules={{ required: "Enter name" }}
                    />
                    <FormTextField
                        label="Description"
                        control={control}
                        rules={{ required: "Enter description" }}
                        name="description"
                        errors={errors}
                        multiline={true}
                    />
                </Stack>
            </FormFields>
            <FormActions
                isLoading={formState.isSubmitting || formState.isValidating}
                onCancel={handleCancelButtonClick}
            />
        </Form>
    );
};
